import axios from 'axios'
import Qs from 'qs'
import { MONARCH_URL } from '../config'
import { getAccessToken } from '../util/helper'

const monarch = axios.create({
  baseURL: MONARCH_URL,
  responseType: 'json',
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getAccessToken()}`
  },
  paramsSerializer(params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' })
  }
})

export default monarch



// WEBPACK FOOTER //
// ./src/app/common/client/monarch.js